export default {
  getOnlineEnrollmentsRequest (state) {
    state.loading = true
    state.onlineEnrollments = []
  },
  getOnlineEnrollmentsSuccess (state, data) {
    state.loading = false
    state.onlineEnrollments = data
  },
  getOnlineEnrollmentsFailure (state) {
    state.loading = true
    state.onlineEnrollments = []
  },

  getOnlineEnrollmentRequest (state) {
    state.loading = true
    state.onlineEnrollment = {}
  },
  getOnlineEnrollmentSuccess (state, data) {
    state.loading = false
    state.onlineEnrollment = data
  },
  getOnlineEnrollmentFailure (state) {
    state.loading = true
    state.onlineEnrollments = {}
  }
}
